import { FC } from 'react';

import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

import { LabelsFilter } from '@assets/icons';

type LabelsFilterButtonProps = {
  count?: number;
};

const LabelsFilterButton: FC<LabelsFilterButtonProps> = ({ count = 0 }) => {
  return (
    <button
      className={twMerge(
        classNames(
          'flex items-center gap-2 border border-button-secondary-hover-stroke rounded-md px-3 hover:bg-button-secondary-hover-bg h-8',
          count > 0 ? 'bg-button-secondary-hover-bg' : 'bg-white',
        ),
      )}
    >
      <div className="flex items-center gap-1">
        <LabelsFilter size={16} className="tex-button-secondary-default-text" />
        <span className="text-sm text-button-secondary-default-text font-medium">
          Labels
        </span>
      </div>

      {count > 0 && (
        <span className="ml-1 border border-stroke-medium rounded-md px-1 py-0.5 text-xs text-black">
          +{count}
        </span>
      )}
    </button>
  );
};

export default LabelsFilterButton;
